import { createBooleanParameter } from './parameterManagement';

const ADVANCED_MODE_PARAM = "advanced";
const ADVANCED_MODE_PARAM_DEFAULT = false;

const [, useAdvancedMode] = createBooleanParameter(ADVANCED_MODE_PARAM, ADVANCED_MODE_PARAM_DEFAULT);

export {
    useAdvancedMode
};
